import { axiosPost } from '../ServiceBase.js';

export const findConsumoPrestacional = async (data) => {
  const consumoPrestacional = await axiosPost('/v1/busquedas/consumo-prestacional/buscar', data);
  return consumoPrestacional;
};
